module.exports = __webpack_public_path__ + "static/media/humanitarian-logo.31233117.svg";